import createSagaMonitor from '@clarketm/saga-monitor';
import { PayloadAction } from '@reduxjs/toolkit';
import { createLogger } from 'redux-logger';

export const createReduxLogger = (app: 'D7' | 'OHIF') => {
  return createLogger({
    collapsed: true,
    diff: true,
    titleFormatter: (action: PayloadAction) => `[${app}] ${action.type}`,
    duration: true,
    timestamp: true,
    level: 'info',
    logErrors: true,
  });
};

export const createSagaLogger = (hasLogs: boolean) => {
  if (!hasLogs) {
    return;
  }
  return {
    sagaMonitor: createSagaMonitor(),
  };
};
